<template>
	<div class="container swiper-container swiper-container--home" :class="[{'d-none d-md-block': !mobileSlider && !isShopbuilder}, {'d-md-none': mobileSlider && !isShopbuilder} ]">
		<div class="swiper-wrapper">
			<div v-for="(slide, index) in slides" class="swiper-slide home-slider__swiper-slide">
				<template v-if="slide.type === 'image' && (slide.gridType === 'row' || slide.gridType === 'grid')">
					<div class="home-slider__row-layout" v-if="slide.gridType === 'row'">
						<a :href="slide.url">
							<lazy-img
								picture-class="img-cover img-fluid"
								:image-url="slide.imageUrl"
								:fallback-url="slide.imageUrl"
								:alt="slide.imageAltText">
							</lazy-img>
						</a>

						<a :href="slide.url2">
							<lazy-img
								picture-class="img-cover img-fluid"
								:image-url="slide.imagePath2"
								:fallback-url="slide.imagePath2"
								:alt="slide.imageAltText">
							</lazy-img>
						</a>

						<a :href="slide.url3">
							<lazy-img
								picture-class="img-cover img-fluid"
								:image-url="slide.imagePath3"
								:fallback-url="slide.imagePath3"
								:alt="slide.imageAltText">
							</lazy-img>
						</a>
					</div>

					<div class="home-slider__grid-layout" v-else>
						<div>
							<a :href="slide.url">
								<lazy-img
									picture-class="img-cover img-fluid"
									:image-url="slide.imageUrl"
									:fallback-url="slide.imageUrl"
									:alt="slide.imageAltText">
								</lazy-img>
							</a>

							<a :href="slide.url2">
								<lazy-img
									picture-class="img-cover img-fluid"
									:image-url="slide.imagePath2"
									:fallback-url="slide.imagePath2"
									:alt="slide.imageAltText">
								</lazy-img>
							</a>
						</div>

						<a :href="slide.url3">
							<lazy-img
								picture-class="img-cover img-fluid"
								:image-url="slide.imagePath3"
								:fallback-url="slide.imagePath3"
								:alt="slide.imageAltText">
							</lazy-img>
						</a>
					</div>
				</template>

				<a v-else :href="slide.url" :target="slide.openInNewTab ? '_blank' : '_self'">
					<template v-if="slide.type === 'image'">
						<img v-if="index === 1" :src="slide.imageUrl" class="img-cover img-fluid" :alt="slide.imageAltText">
						<lazy-img v-else
								  picture-class="img-cover img-fluid"
								  :image-url="slide.imageUrl"
								  :fallback-url="slide.imageUrl"
								  :alt="slide.imageAltText">
						</lazy-img>
					</template>
					<template v-else>
						<div class="home-slider__product-wrapper d-md-flex">
							<div class="col-12 col-md-5 home-slider__item-image">
								<img v-if="index === 1" :src="slide.imageUrl" class="img-cover img-fluid" :alt="slide.imageAltText">
								<lazy-img v-else
										  picture-class="img-cover img-fluid"
										  :image-url="slide.imageUrl"
										  :fallback-url="slide.imageUrl"
										  :alt="slide.imageAltText">
								</lazy-img>
							</div>
							<div class="col-12 offset-xl-1 col-md-5 d-flex align-self-center">
								<div class="home-slider__item-infos">
									<div v-if="slide.customPrice || slide.prices" class="headline__92">
										<price-switch :prices="slide.prices"
													  :custom-price="slide.customPrice">
										</price-switch>
									</div>
									<div class="headline__62 text-primary mt-2 mb-2">
										{{ slide.name }}
									</div>
									<div class="text home-slider__text mb-2">
										{{ slide.text }}
									</div>
									<div class="btn btn-secondary home-slider__btn">
										{{ slide.btntext }}
										<svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" class="my-2">
											<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-arrow"></use>
										</svg>
									</div>
								</div>
							</div>
						</div>
					</template>
				</a>
			</div>
		</div>
		<div class="swiper-scrollbar swiper-scrollbar--home"></div>
		<div class="swiper-pagination swiper-pagination--home"></div>
		<div class="swiper-button-prev swiper-button-prev--home swiper-button-disabled"></div>
		<div class="swiper-button-next swiper-button-next--home"></div>
	</div>
</template>

<script>
	import {Swiper} from "swiper";

	export default {
		props: {
			slides: Array,
			mobileSlider: Boolean,
			isShopbuilder: Boolean,
		},

		mounted(){
			this.initSwiper()
		},

		computed:{

		},

		methods:{

			initSwiper(){
				new Swiper('.swiper-container--home', {
					spaceBetween  : 0,
					slidesPerView : 1,
					navigation: {
						nextEl: ".swiper-button-next--home",
						prevEl: ".swiper-button-prev--home"
					},
					pagination: {
						el: '.swiper-pagination--home',
						type: 'fraction',
					},
					scrollbar: {
						el: '.swiper-scrollbar--home',
						hide: false,
					}
				});
			}
		}
	}
</script>
